import React from "react";
import { 
  Col, 
  Row, 
  Button
} from "reactstrap";
import { useTranslation } from "react-i18next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const EarningsTable = ({ tableData }) => {  

  const { t } = useTranslation();

  const months = [
    t("accounting.add.form.table.label.month_january"),
    t("accounting.add.form.table.label.month_february"),
    t("accounting.add.form.table.label.month_march"),
    t("accounting.add.form.table.label.month_april"),
    t("accounting.add.form.table.label.month_may"),
    t("accounting.add.form.table.label.month_june"),
    t("accounting.add.form.table.label.month_july"),
    t("accounting.add.form.table.label.month_august"),
    t("accounting.add.form.table.label.month_september"),
    t("accounting.add.form.table.label.month_october"),
    t("accounting.add.form.table.label.month_november"),
    t("accounting.add.form.table.label.month_december")
  ];

  const monthFormatter = (cell, row) => {
    cell = months[cell - 1];
    return cell;
  };

  const amountFormatter = (cell, row) => `${cell.toFixed(2)} €`;

  const statusFormatter = cell =>
    cell === 0 ? (
      <Button className="btn-status" disabled color="warning">
        {t("accounting.add.form.table.label.status_open")}
      </Button>
    ) : cell === 1 ? (
      <Button className="btn-status" disabled color="success">
        {t("accounting.add.form.table.label.status_accounted")}
      </Button>
    ) : null;

  const columns = [
    {
      dataField: "month",
      text: t("accounting.add.form.table.columns.month"),
      sort: true,
      formatter: monthFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: "year",
      text: t("accounting.add.form.table.columns.year"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: "total_revenue",
      text: t("accounting.add.form.table.columns.revenue"),
      sort: true,
      formatter: amountFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: "status",
      text: t("accounting.add.form.table.columns.status"),
      sort: true,
      formatter: statusFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
  ];


  return (
    <div>
      <ToolkitProvider
        keyField="id"
        data={tableData}
        columns={columns}
      >
        {props => (
          <div>
            <Row>
              <Col>
              </Col>
              <Col>
                <div className="flexEndContainer">
                </div>
              </Col>
            </Row>
            <BootstrapTable
              {...props.baseProps}
              bordered={ false }
              remote={ { sort: false } }
            />
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default EarningsTable;
